import type { ReactNode } from "react";
import {
  OverlayArrow,
  Focusable as ReactAriaFocusable,
  Tooltip as ReactAriaTooltip,
  TooltipProps as ReactAriaTooltipProps,
  TooltipTrigger as ReactAriaTooltipTrigger,
  type TooltipTriggerComponentProps as ReactAriaTooltipTriggerProps,
} from "react-aria-components";

import { cn } from "../utils";

export const ncTooltipClasses = {
  tooltip: cn(
    "rounded-sm bg-dark text-light shadow-lg px-4 py-2",
    "data-[placement='top']:data-entering:animate-slide-in-top data-[placement='top']:data-exiting:animate-slide-out-top",
    "data-[placement='bottom']:data-entering:animate-slide-in-bottom data-[placement='bottom']:data-exiting:animate-slide-out-bottom",
    "data-[placement='right']:data-entering:animate-slide-in-right data-[placement='right']:data-exiting:animate-slide-out-right",
    "data-[placement='left']:data-entering:animate-slide-in-left data-[placement='left']:data-exiting:animate-slide-out-left"
  ),
  arrow:
    "data-[placement='bottom']:*:rotate-180 data-[placement='right']:*:rotate-90 data-[placement='left']:*:rotate-270",
};

export interface NcTooltipProps extends ReactAriaTooltipProps {
  children: ReactNode;
}

const NcTooltip = ({ children, placement, offset = 8, className, ...props }: NcTooltipProps) => {
  return (
    <ReactAriaTooltip
      data-nc="NcTooltip"
      className={cn(ncTooltipClasses.tooltip, className)}
      placement={placement}
      offset={offset}
      {...props}
    >
      <OverlayArrow className={ncTooltipClasses.arrow}>
        <svg width={8} height={8} viewBox="0 0 8 8" className="block">
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      {children}
    </ReactAriaTooltip>
  );
};

export type NcTooltipTriggerProps = ReactAriaTooltipTriggerProps;

const TooltipTrigger = ({ delay = 250, ...props }: NcTooltipTriggerProps) => {
  return <ReactAriaTooltipTrigger data-nc="NcTooltip.Trigger" delay={delay} {...props} />;
};

NcTooltip.Trigger = TooltipTrigger;
NcTooltip.Focusable = ReactAriaFocusable;

export { NcTooltip };
